
const planPanorama = (() => {

  const pagePlan = (document.getElementById("pagePlan") != null);
  if (pagePlan) {

    document.addEventListener('DOMContentLoaded', function () {

      let sW = document.documentElement.clientWidth;
      let volume;
      if (sW > 750) {
        volume = 1.0;
      } else {
        volume = 1.428;
      }
      let panoramaImg = document.getElementById('panoramaImg');
      let panoramaBox = document.getElementById('panoramaBox');
      let panoramaW = panoramaImg.clientWidth
      // console.log(panoramaW / volume);
      panoramaBox.scrollTo({
        left: panoramaW / volume,
        // behavior: 'smooth',
      });


      let iconScroll = document.getElementById('iconScroll');
      let flag = 0;
      panoramaBox.addEventListener('scroll', () => {
        flag = flag + 1
        if (flag == 2) {
          iconScroll.classList.add('none')
        }
      });


      let iconPrev = document.getElementById('iconPrev');
      let iconNext = document.getElementById('iconNext');

      const nextMove = () => {
        let scroll = panoramaBox.scrollLeft
        panoramaBox.scrollTo({
          left: scroll + 1,
        });
      }
      const prevMove = () => {
        let scroll = panoramaBox.scrollLeft
        panoramaBox.scrollTo({
          left: scroll - 1,
        });
      }

      let nextInterval;
      iconNext.addEventListener('mouseover', () => {
        nextInterval = setInterval(nextMove, 5);
      }, false);
      iconNext.addEventListener('mouseleave', () => {
        clearInterval(nextInterval);
      }, false);

      let prevInterval;
      iconPrev.addEventListener('mouseover', () => {
        prevInterval = setInterval(prevMove, 5);
      }, false);
      iconPrev.addEventListener('mouseleave', () => {
        clearInterval(prevInterval);
      }, false);

    });

  }
})();
export default planPanorama;